var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import Button from '@mui/material/Button';
import FormLabel from '@mui/material/FormLabel';
import IconButton from '@mui/material/IconButton/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import React, { useEffect, useState } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { doPasswordValidation, submitResetPassword, validateResetPaswordToken } from '../../../api/userService';
import GenericModal from '../../common/Modals/GenericModal/GenericModal';
import { log } from '../../../utils/logger';
import { capitaliceWord } from '../../../utils/textUtils';
import PrimaryButton from '../../common/Buttons/PrimaryButton';
import MenuLanguages from '../../common/MenuLanguages/MenuLanguages';
import ContactInfoModal from '../../common/Modals/ContactInfo/ContactInfoModal';
import MainContainer from '../MainContainer';
import ErrorComponent from '../Error/ErrorComponent';
import { ErrorEnum } from '../Error/ErrorEnum';
const ResetPassword = () => {
    const { t, i18n } = useTranslation();
    const { showBoundary } = useErrorBoundary();
    const [errorMessage, setErrorMessage] = useState(false);
    const [password, setPassword] = useState('');
    const [userToken, setUserToken] = useState('');
    const [userName, setUserName] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = React.useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
    const [isValidPassword, setIsValidPassword] = useState(false);
    const [isTokenExpired, setIsTokenExpired] = useState(false);
    const [isDisabledForm, setIsDisabledForm] = useState(true);
    const [isTouchedPassword, setIsTouchedPassword] = useState(false);
    const [errorPasswordsAreDifferentMessage, setErrorPasswordsAreDifferentMessage] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const susccesMessageDialog = {
        title: 'resetPassword.modalExitChangePasswordTitle',
        text: 'resetPassword.modalExitChangePasswordText',
    };
    const errorMessageDialog = {
        title: 'common.errors.commonErrorModalTitle',
        text: 'resetPassword.modalExitChangePasswordTextError',
    };
    const [contentModal, setContentModal] = useState(susccesMessageDialog);
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleClickShowConfirmPassword = () => setShowConfirmPassword((show) => !show);
    const navigate = useNavigate();
    const { hashPassword } = useParams();
    //LANGUAGE
    const [anchorLanguage, setAnchorLanguage] = React.useState(null);
    const handleOpenLanguage = (event) => {
        setAnchorLanguage(event.currentTarget);
    };
    const handleCloseLanguage = () => {
        setAnchorLanguage(null);
    };
    const handleSubmit = (event) => __awaiter(void 0, void 0, void 0, function* () {
        event.preventDefault();
        try {
            const hasResetPassword = yield submitResetPassword({
                username: userName,
                password: password,
            }, userToken);
            if (hasResetPassword) {
                setContentModal(susccesMessageDialog);
            }
            else {
                setContentModal(errorMessageDialog);
            }
            setOpenDialog(true);
        }
        catch (e) {
            log.error('Error calling Reset Password endpoint', e);
            showBoundary(e);
        }
    });
    useEffect(() => {
        const validatePassword = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const isPasswordValid = yield doPasswordValidation(password);
                setIsValidPassword(isPasswordValid);
                if (password === '') {
                    setIsDisabledForm(true);
                }
                if (confirmPassword === '') {
                    setErrorPasswordsAreDifferentMessage(false);
                }
                if (isPasswordValid) {
                    if (confirmPassword.length && password.length && confirmPassword !== password) {
                        setErrorPasswordsAreDifferentMessage(true);
                        setIsDisabledForm(true);
                    }
                    if (confirmPassword.length && password.length && confirmPassword === password) {
                        setErrorPasswordsAreDifferentMessage(false);
                        setIsDisabledForm(false);
                    }
                }
                else {
                    setErrorPasswordsAreDifferentMessage(false);
                    setIsDisabledForm(true);
                }
            }
            catch (e) {
                log.error('Error calling validate password endpoint', e);
                showBoundary(e);
            }
        });
        validatePassword().then(() => log.debug('Validate password call finished'));
    }, [password, confirmPassword]);
    useEffect(() => {
        const resultValidateResetPasswordToken = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const resultValidateResetPasswordToken = yield validateResetPaswordToken(hashPassword);
                if (!resultValidateResetPasswordToken.isExpired && resultValidateResetPasswordToken.isValid) {
                    setUserToken(resultValidateResetPasswordToken.jwtToken);
                    setUserName(resultValidateResetPasswordToken.userName);
                }
                else {
                    setIsTokenExpired(true);
                }
            }
            catch (e) {
                log.error('Error validate token reset password endpoint', e);
                showBoundary(e); // Asegurar que sea un Error válido
            }
        });
        if (hashPassword) {
            resultValidateResetPasswordToken();
        }
        else {
            navigate('/');
        }
    }, []);
    const backToLogin = (event) => {
        event.preventDefault();
        navigate('/');
        setOpenDialog(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx(ContactInfoModal, {}), _jsxs(MainContainer, Object.assign({ isCollectiveApiResponded: true }, { children: [_jsx(Helmet, { children: _jsx("title", { children: "Signo | Reset password" }) }), _jsxs("div", Object.assign({ className: "language-registration" }, { children: [_jsxs(IconButton, Object.assign({ onClick: handleOpenLanguage, "aria-label": t('common.ariaLabels.languages') }, { children: [_jsx(LanguageOutlinedIcon, {}), _jsx("span", Object.assign({ className: "language-text" }, { children: capitaliceWord(i18n.language) }))] })), _jsx(MenuLanguages, { anchorEl: anchorLanguage, onClose: handleCloseLanguage })] })), isTokenExpired ? _jsx(ErrorComponent, { error: ErrorEnum.USER_TOKEN_RESET_PASSWORD_EXPIRED }) : (_jsxs("form", Object.assign({ onSubmit: handleSubmit, className: "main-content reset-password-pageX" }, { children: [_jsx("h1", Object.assign({ className: "reset-password-pageX__title grid-mb-2" }, { children: t('resetPassword.title') })), _jsx("p", Object.assign({ className: "fs-16 mb-2" }, { children: t('resetPassword.firstText') })), _jsx("p", Object.assign({ className: "fs-16 grid-mb-2" }, { children: t('resetPassword.secondText') })), _jsxs("div", Object.assign({ className: "reset-password-pageX__body grid-mb-2" }, { children: [errorMessage && (_jsxs("div", Object.assign({ className: "error-message alert alert-danger", role: "alert" }, { children: [_jsx(ErrorOutlineIcon, { color: "secondary" }), _jsx("span", { children: t('loginPageTexts.errorMessage') })] }))), _jsxs("div", Object.assign({ className: "reset-password-pageX__body-inputs" }, { children: [_jsxs("div", Object.assign({ className: "input-reset-password-wrapper" }, { children: [_jsx(FormLabel, Object.assign({ className: "lbl-reset-password" }, { children: t('resetPassword.lblPassword') })), _jsx(TextField, { error: !!(isTouchedPassword && password.length > 0 && !isValidPassword), className: "input-reset-password", name: "password", fullWidth: true, variant: "outlined", size: "small", value: password, required: true, type: showPassword ? 'text' : 'password', "aria-label": t('resetPassword.lblPassword'), helperText: !!(isTouchedPassword && password.length > 0 && !isValidPassword) ? t('resetPassword.errorFormatPassword') : '', onChange: (e) => setPassword(e.target.value), onFocus: () => setIsTouchedPassword(true), slotProps: {
                                                            input: {
                                                                endAdornment: (_jsx(InputAdornment, Object.assign({ position: "end" }, { children: _jsx(IconButton, Object.assign({ "aria-label": showPassword ? t('lblHidePassword') : t('lblViewPassword'), onClick: handleClickShowPassword, edge: "end" }, { children: showPassword ? _jsx(VisibilityOffOutlinedIcon, {}) : _jsx(VisibilityOutlinedIcon, {}) })) }))),
                                                            },
                                                        } })] })), _jsxs("div", Object.assign({ className: "input-reset-password-wrapper" }, { children: [_jsx(FormLabel, Object.assign({ className: "lbl-reset-password" }, { children: t('resetPassword.lblConfirmPassword') })), _jsx(TextField, { className: "input-reset-password", name: "showConfirmPassword", error: errorPasswordsAreDifferentMessage, fullWidth: true, variant: "outlined", size: "small", value: confirmPassword, required: true, type: showConfirmPassword ? 'text' : 'password', "aria-label": t('resetPassword.lblConfirmPassword'), helperText: errorPasswordsAreDifferentMessage && t('resetPassword.errorNoMachPasswrods'), onChange: (e) => setConfirmPassword(e.target.value), slotProps: {
                                                            input: {
                                                                endAdornment: (_jsx(InputAdornment, Object.assign({ position: "end" }, { children: _jsx(IconButton, Object.assign({ "aria-label": showConfirmPassword ? t('lblHidePassword') : t('lblViewPassword'), onClick: handleClickShowConfirmPassword, edge: "end" }, { children: showConfirmPassword ? _jsx(VisibilityOffOutlinedIcon, {}) : _jsx(VisibilityOutlinedIcon, {}) })) }))),
                                                            },
                                                        } })] }))] })), _jsxs("p", Object.assign({ className: "fs-12 grid-mt-2" }, { children: ["* ", t('resetPassword.disclaimer')] }))] })), _jsx(PrimaryButton, { cssClass: "btn-login", text: t('common.btn.confirm'), testId: "login-btn", isDisabled: isDisabledForm, submitButton: true })] })))] })), _jsx(GenericModal, Object.assign({ open: openDialog, title: t(contentModal.title), cssProps: { maxWidth: '450px' }, primaryAction: _jsx(Button, Object.assign({ onClick: (event) => {
                        backToLogin(event);
                    }, variant: "contained", color: "primary" }, { children: t('common.btn.goToLogin') })) }, { children: _jsx("p", { className: "fs-16 mb-3 feedback-reset-password-modal", dangerouslySetInnerHTML: { __html: t(contentModal.text) } }) }))] }));
};
export default ResetPassword;
